





















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Message } from "../models/message";
import MessageMetaCard from "./MessageMetaCard.vue";
import { getMessageBody } from "../api";
@Component({
  components: { MessageMetaCard },
})
export default class MessageReadBlock extends Vue {
  @Prop({ required: true, type: Object }) public value!: Message;

  private body = "";

  @Watch("value.id", { immediate: true })
  private async onValueChange(id: number, old: number) {
    if (id === old || id === 0) return;

    this.body = await getMessageBody(id);
  }
}
